module.exports = __webpack_public_path__ + "static/media/contact-header.73d7849f.jpg";